import { Button, Card, Hero, Section, StatBar } from '../components/ui';

const heroStats = [
  { label: 'Accuracy', value: '99.2%' },
  { label: 'Avg. Processing Time', value: '2.8s' },
  { label: 'Documents / Month', value: '10k+' }
];

const featureList = [
  {
    title: 'Visual Workflow Builder',
    description:
      'Design custom extraction workflows with drag-and-drop nodes. No code required—configure fields, master data mappings, and outputs visually.'
  },
  {
    title: 'Drive: Batch Processing',
    description:
      'Upload hundreds of documents to folders, assign workflows, and process everything with one click. Track progress in real-time.'
  },
  {
    title: 'Smart Master Data Matching',
    description:
      'Upload your CSV/XLS catalogs, select mappable fields, and automatically enrich extracted data with vendor details, pricing, and SKUs.'
  },
  {
    title: 'ERP-Ready Outputs',
    description:
      'Generate structured JSON/CSV outputs with merged extraction and master data, ready for direct import into SAP, NetSuite, and more.'
  }
];

const benefits = [
  'Visual workflow builder—no coding required',
  'Folder-based batch processing with real-time progress tracking',
  'User-defined master tables via CSV/XLS upload',
  'Multi-tenant isolation with organization-specific controls',
  'SOC 2-ready security posture and complete audit trails',
  'Automated exception handling and queue-based reprocessing'
];

export const Home = () => {
  return (
    <>
      <Hero
        eyebrow="Enterprise Document Processing"
        title="Document automation without compromise."
        description="textadapt ingests invoices, receipts, and purchase orders, then delivers ERP-ready data with LLM-driven accuracy and embedded controls."
        primaryAction={
          <Button variant="primary" size="lg" as="a" href="/contact">
            Request a demo
          </Button>
        }
        secondaryAction={
          <Button
            variant="outline"
            size="lg"
            as="a"
            href="/pricing"
            className="!bg-white/10 !text-white !border-white/30 hover:!bg-white/20 hover:!border-white/50"
          >
            View pricing
          </Button>
        }
        background="/hero-bg.png"
      >
        <StatBar stats={heroStats} divider />
      </Hero>

      <Section title="Why textadapt" subtitle="A control plane for AP, Procurement, and Finance Ops" centered>
        <div className="feature-grid">
          {featureList.map((feature, index) => (
            <Card key={feature.title} elevation="lg" className="feature-card">
              <span className="feature-card__index">{String(index + 1).padStart(2, '0')}</span>
              <div className="feature-card__content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </Section>

      <Section title="Launch Roadmap" subtitle="Measured value in every phase" background="subtle" centered>
        <ol className="roadmap">
          <li>
            <h4>Pilot in 14 days</h4>
            <p>
              Upload representative documents, calibrate extraction, and validate outputs with guided, human-in-the-loop review.
            </p>
          </li>
          <li>
            <h4>Automate with policy controls</h4>
            <p>
              Connect master data sources, enforce tolerances, and orchestrate exception queues that mirror your approval process.
            </p>
          </li>
          <li>
            <h4>Scale across the enterprise</h4>
            <p>
              Leverage regional data enclaves, granular permissions, and enterprise SSO as you expand to new business units.
            </p>
          </li>
        </ol>
      </Section>

      <Section title="What you get" subtitle="Modern operations toolkit" centered>
        <ul className="benefits">
          {benefits.map((benefit) => (
            <li key={benefit}>{benefit}</li>
          ))}
        </ul>
      </Section>
    </>
  );
};
